import { createContext, SetStateAction } from 'react';

import {
  ODSemenItem,
  PulledSemenItem,
  ScheduledSemenItem,
} from '@/services/semen-pull';
import { SiteOption } from '@/services/sites';

import { ExtraSemenLabel, SemenState } from './types';

const SemenPullContext = createContext<{
  sites: SiteOption[] | undefined;
  setSites: React.Dispatch<SetStateAction<SiteOption[] | undefined>>;
  selectedSite: SiteOption | undefined;
  ODselectedSemen: ODSemenItem | undefined;
  setODselectedSemen: React.Dispatch<SetStateAction<ODSemenItem | undefined>>;
  semenState: SemenState;
  setSemenState: React.Dispatch<SetStateAction<SemenState>>;
  scheduledSemen: ScheduledSemenItem[] | undefined;
  pulledSemen: PulledSemenItem[] | undefined;
  extraSemenLabels: ExtraSemenLabel[];
  setExtraSemenLabels: React.Dispatch<SetStateAction<ExtraSemenLabel[]>>;
  currentScheduledSemen: ScheduledSemenItem | undefined;
  setCurrentScheduledSemen: React.Dispatch<
    SetStateAction<ScheduledSemenItem | undefined>
  >;
  currentPulledSemen: PulledSemenItem | undefined;
  refetchScheduledSemen: () => void;
  refetchPulledSemen: () => void;
} | null>(null);

export default SemenPullContext;
